/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Avg_Speed_One_LinerInputs */

const en_exp_avg_speed_one_liner = /** @type {(inputs: Exp_Avg_Speed_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your average speed in km/h, the primary intensity metric for cycling.`)
};

const de_exp_avg_speed_one_liner = /** @type {(inputs: Exp_Avg_Speed_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Ø-Geschwindigkeit in km/h — die Kernmetrik fürs Radfahren.`)
};

/**
* | output |
* | --- |
* | "Your average speed in km/h, the primary intensity metric for cycling." |
*
* @param {Exp_Avg_Speed_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_avg_speed_one_liner = /** @type {((inputs?: Exp_Avg_Speed_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Avg_Speed_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_avg_speed_one_liner(inputs)
	return de_exp_avg_speed_one_liner(inputs)
});